import { PermissionEnum } from '@api/enum';
import { IProjectLink } from '@api/models/project-links.model';
import useAuthPermission from '@hooks/use-auth-permission';
import useDialog from '@hooks/use-dialog';
import { Button, Table } from '@hyperflake/react-ui-library';
import { DeleteShapeIcon, EditIcon } from '@icon/index';
import { Tooltip } from '@library/tooltip';
import useLinkListData from 'modules/links/hooks/useLinkListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useNavigate, useParams } from 'react-router-dom';
import LinkDeleteConfirmationDrawer from '../LinkDeleteConfirmationDrawer/LinkDeleteConfirmationDrawer';

const LinkList = () => {
    const { clientId, projectId } = useParams();
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();
    const linkListData = useLinkListData(clientId, projectId);
    const deleteLinkDailog = useDialog<IProjectLink>();

    // const dummy = [
    //     {
    //         _id: 'ABC',
    //         name: 'abc',
    //         url: 'https://abc.com',
    //     },
    //     {
    //         _id: 'def',
    //         name: 'def',
    //         url: 'https://def.com',
    //     },
    // ];

    return (
        <PageTemplate>
            <div className="flex justify-between">
                <PageHeading>Links</PageHeading>

                {hasPermission(PermissionEnum.CLIENT_CREATE) && (
                    // <Button onClick={addClientDialog.show}>Add Client</Button>
                    <Button onClick={() => navigate('add-link')}>Add Link</Button>
                )}
            </div>

            <Table
                className="mt-6"
                borderStyle="divider"
                hover
                isLoading={linkListData.isLoading}
                data={linkListData.links}
                // data={dummy}
                columns={[
                    {
                        header: 'ID',
                    },
                    {
                        header: 'Name',
                    },
                    {
                        header: 'Url',
                    },
                    {
                        header: 'Actions',
                    },
                ]}
                renderRow={(row) => (
                    <Table.Row key={row._id}>
                        <Table.Cell>{row._id}</Table.Cell>
                        <Table.Cell>{row.name}</Table.Cell>
                        <Table.Cell>{row.url}</Table.Cell>
                        <Table.Cell>
                            <div className="grid gap-4 grid-cols-2">
                                <Tooltip placement="top" content={'Edit'}>
                                    <button
                                        onClick={() =>
                                            // editUserDailog.show(row)
                                            navigate(
                                                `/clients/${clientId}/projects/${projectId}/links/${row._id}/edit-link`
                                            )
                                        }
                                    >
                                        <EditIcon />
                                    </button>
                                </Tooltip>

                                <Tooltip placement="top" content={'Delete'}>
                                    <button
                                        onClick={
                                            () => deleteLinkDailog.show(row)
                                            // null
                                        }
                                    >
                                        <DeleteShapeIcon />
                                    </button>
                                </Tooltip>
                            </div>
                        </Table.Cell>
                    </Table.Row>
                )}
            />
            <LinkDeleteConfirmationDrawer
                open={deleteLinkDailog.isOpen}
                onClose={deleteLinkDailog.hide}
                link={deleteLinkDailog.data}
            />
        </PageTemplate>
    );
};

export default LinkList;
